import React, { Fragment } from 'react';
import { ArrowIcon, ListItemLink } from '@/se/components/collection/mobile/ListItem';
import { Column, Label, Value, TwoItemSection } from '@/se/components/collection/mobile/shared';
import RouterLink from '@/se/components/RouterLink';

const PhysicianMobileListItem = ({
  history,
  location,
  columns,
  item,
  context,
  index: i,
  showUrlProvider,
  idProvider,
  onClick,
}) => {
  if (item.separator) {
    return null;
  }
  const nameColumn = columns.find(_ => _.title === 'Name');
  const notificationNumbersColumn = columns.find(_ => _.title === 'SMS Notification Numbers');
  const sendNotificationColumn = columns.find(_ => _.title === 'Send Notification');

  return (
    <Fragment>
      <ListItemLink
        component={showUrlProvider ? RouterLink : undefined}
        to={
          showUrlProvider
            ? {
                pathname: showUrlProvider(idProvider(item)),
                search: location.search,
              }
            : undefined
        }
        onClick={onClick}
      >
        <ArrowIcon />
        <Column style={{ marginBottom: '0.75rem' }}>
          <Label>{nameColumn.title}</Label>
          <Value trimText>{nameColumn.lens(item, context)}</Value>
        </Column>

        <TwoItemSection>
          <Column>
            <Label>{notificationNumbersColumn.title}</Label>
            <Value trimText>{notificationNumbersColumn.lens(item, context)}</Value>
          </Column>
          {sendNotificationColumn && (
            <Column>
              <Label>{sendNotificationColumn.title}</Label>
              <sendNotificationColumn.Component data={sendNotificationColumn.lens(item, context)} />
            </Column>
          )}
        </TwoItemSection>
      </ListItemLink>
    </Fragment>
  );
};

export default PhysicianMobileListItem;
